import { Injectable } from '@angular/core';

@Injectable()
export class DialogService {

  public showDialog: boolean;
  public dialogType: string;
  public message: string;
  public dialogId: string;

  constructor() { }

  public openDialog(dialogType: string, message: string, dialogId: string = 'defaultDialog'): void {
    this.showDialog = true;
    this.dialogType = dialogType;
    this.message = message;
      this.dialogId = dialogId;
      let button = document.getElementById("focusme");
      if (button) {
          button.focus();
      }
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

}
